export default {
    show: function() {
        this.modalHeight = $(document).height();
        if (typeof this.beforeShow === 'function') {
            this.beforeShow(); // Change this to this.trigger('before-show')?
        }
        this.showModal = true;
        this.update();
        this.adjustMarginTop();

        if (
            !this.modalBackground.style.opacity ||
            this.modalBackground.style.opacity === '0'
        ) {
            this.fadeIn();
        }
    },

    hide: function() {
        this.showModal = false;
        this.update();
    },

    close: function() {
        this.showModal = false;

        this.modalBackground.style.opacity = 0;
        this.update();
    },

    fadeIn: function() {
        this.modalBackground.style.opacity = 1;
    },

    adjustMarginTop: function() {
        let scroll = $(document).scrollTop();
        let windowHeight = $(window).height();
        let modalHeight = $(this.modal).height();
        let marginTop = parseInt(
            scroll + windowHeight / 2 - modalHeight / 2,
            10
        );
        this.modal.style.marginTop = (marginTop < 5 ? 5 : marginTop) + 'px';
    },

    onClose: function(evt) {
        if (evt.target === evt.currentTarget) {
            this.showModal = false;
            this.modalBackground.style.opacity = 0;
            this.update();
            this.bus.trigger('ui:modal-container:after-close');
        }
        return true;
    }
};
